import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ContractService } from 'src/app/services/contract.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { HttpClient } from '@angular/common/http';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-advertising-box',
  templateUrl: './advertising-box.component.html',
  styleUrls: ['./advertising-box.component.scss']
})
export class AdvertisingBoxComponent implements OnInit {
  finishedLoading:boolean = false;
  loadedIMG:boolean = false;
  addForm: UntypedFormGroup;
  intoBoxes = [];
  activeBoxes = []
  ReturnintoBoxes = []


  constructor(
    private fb: UntypedFormBuilder,
    private contractService: ContractService,
    private attachmentService: AttachmentService,
    private http: HttpClient,
    private overlayService: OverlayService
  ) {
    this.addForm = this.fb.group({
      image: [''],
      imageAlignMent: ["LEFT", [Validators.required]],
      state: ['NEW', [Validators.required]],
      text: ['', Validators.required]
    })
  }

  ngOnInit() {

    this.finishedLoading = false;
    this.contractService.getContract();
    this.contractService.component_web_intro_landing_page$.subscribe(
      value => {
        this.ReturnintoBoxes = [];
        this.intoBoxes = [];
        if (value != null && value != false) {
          this.intoBoxes = JSON.parse(String(value));
          this.intoBoxes.forEach((element, index) => {
            //Push to select Box Dropdownoptions
            this.activeBoxes.push({ value: element[0], viewValue: `Infobox ${index + 1}` });
            this.attachmentService.getInfoData(element[0]).subscribe(value => {
              this.http.get(value.url, { responseType: 'text' }).subscribe(value => {
                this.intoBoxes[index]["TEXT_FILE"] = value;
              })
            })
            this.attachmentService.getInfoData(element[1]).subscribe(value => {
              this.intoBoxes[index]["IMAGE_FILE"] = value?.url
            })
            this.ReturnintoBoxes.push(element);
          });
          this.finishedLoading = true;
        }else{
          this.finishedLoading = true;
        }
      })
  }

  deleteBox(box) {
    let obj = {
      all: this.intoBoxes,
      toDelete: box
    }
    this.overlayService.openDeleteDialog("Wirklich löschen", "Möchten Sie diesen Eintrag wirklich löschen?", "Löschen", "Abbrechen", obj, 'boxes').subscribe(value => {
      this.ngOnInit();
    })
  }
}
